import { UserSocialLinkTypeEnum } from '../enums';

export interface UserSocialLinkInterface {
  type?: UserSocialLinkTypeEnum;
  url?: string;
}
